import { Paper, Stack, Typography } from '@mui/material';
import { Answer, ClosedQuestion, Perspectives } from 'features/lead/lead-questionnaire/lead-questionnaire.types';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import SubCategoryContainer from './sub-category-container';

interface Props {
  perspective?: string;
  closedQuestion: ClosedQuestion;
  answers: Answer[];

  handleRadioSelectionChange?(id: string): (value: string | number) => () => void;
}

const ClosedQuestionsContainer: React.FC<Props> = ({ perspective, closedQuestion, answers, handleRadioSelectionChange }) => {
  const { classes } = useStyles();

  return (
    <Stack gap={4}>
      <Typography className={classes.title}>{closedQuestion.name}</Typography>
      <Typography className={classes.description}>
        {closedQuestion.externalIntroduction && perspective !== Perspectives.SELF
          ? closedQuestion.externalIntroduction
          : closedQuestion.selfIntroduction && perspective === Perspectives.SELF
          ? closedQuestion.selfIntroduction
          : ''}
      </Typography>
      <Stack gap={2}>
        <Stack gap={2}>
          {closedQuestion.subCategories.map(
            (subCategory) =>
              subCategory.questions.length !== 0 && (
                <Paper key={subCategory.id} className={classes.textContainer} elevation={2} square={true}>
                  <SubCategoryContainer
                    perspective={perspective}
                    subCategory={subCategory}
                    answers={answers}
                    handleRadioSelectionChange={handleRadioSelectionChange}
                  />
                </Paper>
              )
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};

const useStyles = makeStyles()((theme) => ({
  title: {
    fontSize: theme.typography.pxToRem(32),
    textAlign: 'center',
    fontWeight: 'bold',
  },
  description: {
    fontSize: theme.typography.pxToRem(18),
    color: theme.palette.greys.medium,
    padding: '0 16px',
  },
  textContainer: {
    background: 'rgba(0,0,0,0.03)',
  },
}));

export default ClosedQuestionsContainer;
